import { ANALYTICS_GO_URL } from "@constants";
import { publicRequest } from "../core/services";
//api request per le ads
// const ads = {
//   //stato della tabellare
//   playingStatus: (data: AdsPlayingTabularRequest) =>
//     publicRequest.post<AdsPlayingStatusResponse>(
//       "/ads/getisadsplayingstatus",
//       data,
//     ),
//   //chiamata al server delle analitiche
//   goApiPlayingStatus: (data: AdsPlayingGoApiRequest) =>
//     publicRequest.post<AdsPlayingStatusResponse>(
//       ANALYTICS_GO_URL,
//       data,
//     ),
// };
//LIB FATTO COSI PER RAPIDITà questo funziona con le vecchia url http
// usare quello sopra una volta creato il modulo api.
const ads = {
    //stato della tabellare
    playingStatus: (data) => publicRequest.post("/ads/getisadsplayingstatus", new URLSearchParams({
        files_id: data.files_id.toString(),
    })),
    //chiamata al server delle analitiche
    goApiPlayingStatus: (data) => publicRequest.post(ANALYTICS_GO_URL, new URLSearchParams({
        rel: data.rel,
    })),
};
export const apiAds = {
    ads
};
